var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHolidayParking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Car-Voyage--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Car Voyage Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 2.5h0.77a0.52 0.52 0 0 1 0.44 0.25 1.49 1.49 0 0 0 1.29 0.75h6A1.5 1.5 0 0 0 17 2v-0.5A1.5 1.5 0 0 0 15.5 0h-6a1.49 1.49 0 0 0 -1.29 0.75 0.52 0.52 0 0 1 -0.44 0.25H7a0.75 0.75 0 0 0 0 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.12 13.28a1 1 0 1 0 -1.24 -1.56l-0.4 0.31a0.48 0.48 0 0 1 -0.5 0.08 0.51 0.51 0 0 1 -0.31 -0.41l0 -0.19a3 3 0 0 0 -3 -2.74H7.34a3 3 0 0 0 -3 2.72l0 0.22a0.51 0.51 0 0 1 -0.31 0.41 0.48 0.48 0 0 1 -0.5 -0.08l-0.4 -0.31a1 1 0 0 0 -1.24 1.56l0.85 0.68a0.54 0.54 0 0 1 0.19 0.37 0.49 0.49 0 0 1 -0.16 0.38A2.49 2.49 0 0 0 2 16.5v2A1.5 1.5 0 0 0 3.5 20h17a1.5 1.5 0 0 0 1.5 -1.5v-2a2.49 2.49 0 0 0 -0.76 -1.79 0.48 0.48 0 0 1 -0.16 -0.38 0.54 0.54 0 0 1 0.19 -0.37ZM6.34 11.67a1 1 0 0 1 1 -0.91h9.32a1 1 0 0 1 1 0.94l0.16 1.5a0.47 0.47 0 0 1 -0.12 0.38 0.5 0.5 0 0 1 -0.37 0.17H6.67a0.5 0.5 0 0 1 -0.37 -0.17 0.47 0.47 0 0 1 -0.12 -0.38ZM5.5 18.5A1.5 1.5 0 1 1 7 17a1.5 1.5 0 0 1 -1.5 1.5Zm13 0A1.5 1.5 0 1 1 20 17a1.5 1.5 0 0 1 -1.5 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21h-3a0.5 0.5 0 0 0 -0.5 0.5v0.5a2 2 0 0 0 4 0v-0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21h-3a0.5 0.5 0 0 0 -0.5 0.5v0.5a2 2 0 0 0 4 0v-0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.5h3s0.5 0 0.5 0.5v2.5s0 0.5 -0.5 0.5h-3s-0.5 0 -0.5 -0.5V5s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6v0.5A1.5 1.5 0 0 0 8.5 8a0.5 0.5 0 0 0 0.5 -0.5V5a0.5 0.5 0 0 0 -0.5 -0.5A1.5 1.5 0 0 0 7 6Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.5a0.5 0.5 0 0 0 -0.5 0.5v2.5a0.5 0.5 0 0 0 0.5 0.5A1.5 1.5 0 0 0 17 6.5V6a1.5 1.5 0 0 0 -1.5 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHolidayParking);
export default ForwardRef;